import './PomPom.css';

import React from 'react';

export interface PomPomProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  color?: 'pink' | 'teal';
  className?: string;
}

const strands = Array.from({ length: 16 }, (_, index) => index + 1);

const PomPom: React.FC<PomPomProps> = ({
  size = 'medium',
  color = 'pink',
  className = '',
}) => (
  <div
    className={[
      'pom-pom',
      `pom-pom--size-${size}`,
      `pom-pom--color-${color}`,
      className,
    ].filter(Boolean).join(' ')}
    aria-hidden="true"
  >
    {strands.map((strandIndex) => (
      <div
        key={strandIndex}
        className={[
          'pom-pom__strand',
          `pom-pom__strand--${strandIndex}`,
        ].join(' ')}
      />
    ))}
    <div className="pom-pom__core" />
  </div>
);

export default PomPom;
